angular.module('admin.groups.add', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'directives.serverError',
  'resources.AdminGroup',
  'ui.bootstrap.dropdown',
  'services.formErrors'
])

.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.groups.add', {
      url: '/add',
      title: 'Account Groups / Details',
      views: {
        'main@': {
          template: require('./group-add.tpl.html'),
          controller: 'AccountGroupAddCtrl',
          // resolve: {
          //   categories: function(adminResource) {
          //     return adminResource.getCategoriesTree({path: '/', depth: 2});
          //   }
          // }
        }
      }
    });
}])

.controller('AccountGroupAddCtrl',
  ["$scope", "$route", "$location", "$log", "utility", "adminResource", "STATUSES", "AdminGroup", "formErrors", "growl", "localizedMessages", function($scope, $route, $location, $log, utility, adminResource, STATUSES, AdminGroup, formErrors, growl, localizedMessages) {
    $scope.localizedMessages = localizedMessages;
    STATUSES = STATUSES.map( (status) => Object.assign(status, { value: localizedMessages.get(status.value) }) );
    adminResource.getCategoriesTree({path: '/', depth: 2}).then(function (categories) {
      $scope.categories = categories;
    });

    $scope.group = {
      statuses: [],
      categories: []
    };
    $scope.statusModel = [];
    $scope.STATUSES = STATUSES;
    $scope.selectSettings = {
      closeList: false
    };
    // local vars
    $scope.isChecked = function (id) {
      return ~$scope.group.categories.indexOf(id) || ~$scope.group.categories.indexOf(id.toString());
    };
    $scope.selectAllStatus = function () {
      $scope.group.statuses = STATUSES;
    };
    $scope.submit = function () {
      var data = angular.copy($scope.group);
      data.sefriendly = data.name.replace(/[^A-Za-z0-9\s-]/g, '').replace(/[\s-]+/g, '-');
      data.statuses = data.statuses.map(function (status) {
        return status.id;
      });
      AdminGroup.save(data, function (result) {
        growl.info('Group saved!');
        $location.path('/admin/groups/' + result._id);
      }, formErrors.growlErrors);
    };
    $scope.changeStatus = function(){
      $scope.statusAlerts = [];
      if($scope.selectedStatus && $scope.selectedStatus._id) {
        if($scope.selectedStatus._id === $scope.group.status.id) {
          // status selected is the current status
          $scope.statusAlerts.push({ type: 'danger', msg: 'That is the current status.'});
        }else{
          // update status
          var data = {
            id: $scope.selectedStatus._id,
            name: $scope.selectedStatus.name
          };
          adminResource.newAccountGroupStatus($scope.group._id, data).then(function(result){
            if(result.success){
              deserializeAccountGroup(result.AccountGroup);
            }else{
              //error due to server side validation
              angular.forEach(result.errors, function(err, index){
                $scope.statusAlerts.push({ type: 'danger', msg: err});
              });
            }
          }, function(x){
            $scope.statusAlerts.push({ type: 'danger', msg: 'Error adding new status: ' + x});
          });
        }
      }else{ //no status is selected
        $scope.statusAlerts.push({ type: 'danger', msg: 'Please choose a status.'});
      }
    };

    $scope.saveStatus = function() {
      var data = $scope.group.statuses.length === STATUSES.length ? ['*'] : $scope.group.statuses;
      adminResource.saveAccountGroupStatus($scope.group._id, data).then(function (result) {
        if(result.success){
          //deserializeAccountGroup(result.AccountGroup);
          $scope.statusAlerts.push({type: 'info', msg: 'Changes have been saved.'});
        }else{
          //error due to server side validation
          angular.forEach(result.errors, function(err, index){
            $scope.statusAlerts.push({ type: 'danger', msg: err});
          });
        }
      }, function(x){
        $scope.statusAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x});
      });
    };

    $scope.toggleNode = function(node) {
      var modelValue = node.$nodeScope.$modelValue;
      var pathLength = modelValue.path.split('/').filter(Boolean).length;
      var objPath = 'children' + (new Array(pathLength).join('.[0].children'));
      var children = {};

      adminResource.getCategoriesTree({path: modelValue.path, depth: 2}).then(function(result) {
        if (!result.length) {
          return;
        }

        result = result[0];

        modelValue.children = _.get(result, objPath);
        node.toggle();
      });
    };

    var categorySelection = function(children){
      for (var i = 0; i < children.length; i++) {
        $log.log('categorySelection---------->'+JSON.stringify(children[i]));
        $scope.group.categories.push(children[i].id.toString());
        if(children[i].children.length > 0){
          categorySelection(children[i].children);
        }
      }
    };
    var categoryDeSelection = function(children){
      for (var i = 0; i < children.length; i++) {
        $scope.group.categories.splice($scope.group.categories.indexOf(children[i].id.toString()), 1);
        if(children[i].children.length > 0){
          categoryDeSelection(children[i].children);
        }
      }
    };

    $scope.toggleCategorySelection = function(categories) {
      var idx = $scope.group.categories.indexOf(categories.id.toString());
      $log.log('');
      if (idx > -1) {
        $scope.group.categories.splice(idx, 1);
        if(categories.children.length > 0){
           categoryDeSelection(categories.children);
        }
      }
      else {
        $scope.group.categories.push(categories.id.toString());
        if(categories.children.length > 0){
           categorySelection(categories.children);
        }
      }      
    };

    $scope.saveCategories = function() {
      adminResource.saveAccountGroupCategories($scope.group._id, $scope.group.categories).then(function (result) {
        if(result.success){
          $scope.categoryAlerts.push({type: 'info', msg: 'Changes have been saved.'});
        }else{
          //error due to server side validation
          angular.forEach(result.errors, function(err, index){
            $scope.categoryAlerts.push({ type: 'danger', msg: err});
          });
        }
      }, function(x){
        $scope.categoryAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x});
      });
    };

    //initialize
    // deserializeData(data);
  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/groups/group-add.js